import { headerItems, mobileHeaderItems } from '@/utils/constants';
import { Icons } from '@/utils/Icons';
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ProfileDrawer from './ProfileDrawer';
import { useDispatch } from 'react-redux';
import { openModal } from '@/store';
import { useIsAuthenticated } from '@/hooks';
import { useGetUserProfileQuery, useGetUserWalletsQuery } from '@/store/api/userApi';
import { useIsDemoUser } from '@/hooks/redux';

interface HeaderProps {
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Header = ({ sidebarOpen, setSidebarOpen }: HeaderProps) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [openDrawer, setOpenDrawer] = useState(false);
  const isAuthenticated = useIsAuthenticated();
  const isDemoUser = useIsDemoUser();

  useGetUserProfileQuery(undefined, { skip: !isAuthenticated });

  const { data: wallets } = useGetUserWalletsQuery(undefined, {
    skip: !isAuthenticated,
    pollingInterval: 5000,
  });

  const mainWallet = wallets?.find((w) => w.type?.toLowerCase() === 'main');
  const mainBalance = parseFloat(mainWallet?.amount ?? '0');

  return (
    <>
      <header className="bg-headerBg h-[67.5px] fixed text-primaryText w-full z-[9] top-0">
        {isDemoUser && (
          <div className="text-[13px] text-center flex justify-center items-center w-[145px] rounded-b-[5px] absolute top-[9px] left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#FF0000] text-white py-1 z-10">
            Demo Account
          </div>
        )}
        <div className="w-full px-3 mx-auto">
          <div className="flex items-center justify-between">
            <div className="flex items-center cursor-pointer w-[300px]">
              <span className="mr-[7px]">
                <Icons.Menu
                  size={14}
                  className="text-black lg:hidden"
                  onClick={() => setSidebarOpen(!sidebarOpen)}
                />
              </span>
              <Link to="/">
                <img src="/images/logo.svg" alt="" />
              </Link>
            </div>
            <div className="max-lg:hidden overflow-y-hidden w-full whitespace-nowrap">
              <div className="flex items-center gap-1 mx-auto px-4 rounded-[50px] relative z-50">
                {headerItems.map((item) => (
                  <div
                    key={item.id}
                    className="text-headerText border-b-[3px] border-transparent group"
                  >
                    <Link
                      to={item.path}
                      className="flex flex-col items-center text-[11px] font-bold uppercase px-[10px] py-2"
                    >
                      <span
                        className={`flex size-8 overflow-hidden items-center justify-center rounded-[50px] group-hover:bg-white ${pathname === `${item.path}` ? 'bg-white' : 'bg-[#1f2c38]'}`}
                      >
                        <img className="w-8 h-auto" src={item.imgUrl} alt={item.title} />
                      </span>

                      {item.title}
                    </Link>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex gap-[6px]">
              {isAuthenticated ? (
                <button
                  onClick={() => setOpenDrawer(true)}
                  className="w-[90%] px-[25px] py-3 text-white text-[14px] rounded-[50px] bg-[#111020] border border-secondaryBg flex items-center justify-center font-bold [filter:var(--btn-dropshadow)]"
                >
                  {mainBalance.toFixed(2)}
                </button>
              ) : (
                <button
                  onClick={() => dispatch(openModal({ name: 'login' }))}
                  className="w-[90%] px-[25px] py-2 text-white text-[14px] rounded-[50px] bg-[#111020] border border-secondaryBg flex items-center justify-center font-bold [filter:var(--btn-dropshadow)] hover:bg-[#fec733]"
                >
                  Login
                </button>
              )}
            </div>
          </div>
        </div>
        <ProfileDrawer open={openDrawer} onClose={() => setOpenDrawer(false)} />
      </header>
      <div className="lg:hidden w-full bg-section-gradient mt-[70px] h-[55px]">
        <div className="overflow-y-hidden whitespace-nowrap w-full">
          <div className="flex items-center gap-1 mx-auto px-4 rounded-[50px]">
            {mobileHeaderItems.map((item) => (
              <div
                key={item.id}
                className="text-headerText border-b-[3px] border-transparent group"
              >
                <Link
                  to={item.title}
                  className="flex flex-col items-center text-[12px] font-bold uppercase px-[10px] py-[5px]"
                >
                  <span
                    className={`flex size-[27px] overflow-hidden items-center justify-center rounded-[50px] group-hover:bg-white ${pathname === `/${item.title}` ? 'bg-white' : 'bg-[#1f2c38]'}`}
                  >
                    <img className="w-[27px] h-auto" src={item.imgUrl} alt={item.title} />
                  </span>

                  {item.title}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
